import { Field, FieldWrapper } from '@progress/kendo-react-form';
import React, { useEffect, useState } from 'react'; 
import {FormCheckboxSquare, HybridFormLabelGrey } from '../validation/Form-Components';
import mData from '../hybriddata/mainform.json';
import wcIcon from '../hybridImages/WorkingCapIcon.png';
import propertyIcon from '../hybridImages/PropertyIcon.png';
import tradeIcon from '../hybridImages/TradeIcon.png';
import govAssistIcon from '../hybridImages/GovAssistIcon.png';
import BlueboxTextList from '../hybridcomponents/BlueboxTextList';
import TotalFinancingAmt from '../hybridcomponents/TotalFinancingAmt';
import { min200KValidator, min20KValidator } from '../validation/Validators';
import BlueboxEsgTxt from '../hybridcomponents/BlueboxEsgTxt';
import esgIcon from '../hybridImages/ESGIcon.PNG';
 
const PersonalisedBizFinancing = (props) => {

    const {fProps, isEditForm, isESGSolution, esgSolutionType} = props;

    const [card1Hover,setCard1Hover] = useState(false);
    const [card2Hover,setCard2Hover] = useState(false);
    const [card3Hover,setCard3Hover] = useState(false);
    const [card4Hover,setCard4Hover] = useState(false);
    const [card5Hover,setCard5Hover] = useState(false);

    const [checkedChkWCL,setCheckedChkWCL] = useState(false);
    const [checkedChkProperty,setCheckedChkProperty] = useState(false);
    const [checkedChkTrade,setCheckedChkTrade] = useState(false);
    const [checkedChkGovAssist,setCheckedChkGovAssist] = useState(false);
    const [checkedChkESG,setCheckedChkESG] = useState(false);

    const [isOnlyPropertyChecked, setIsOnlyPropertyChecked] = useState(false);

    const [disableFinancingAmt, setDisableFinancingAmt] = useState(true);

    useEffect(() => {
        console.log('@PersonalisedBizFinancing useEffect');
        
        const wclValue = fProps.valueGetter('chkWorkingCapital');
        setCheckedChkWCL(wclValue);
        const propertyValue = fProps.valueGetter('chkProperty');
        setCheckedChkProperty(propertyValue);
        const tradeValue =fProps.valueGetter('chkTrade');
        setCheckedChkTrade(tradeValue);
        const govAValue = (isESGSolution && esgSolutionType === mData.esgSolutionFType.Enterprise)?true:fProps.valueGetter('chkGovAssist');
        setCheckedChkGovAssist(govAValue);
        const esgValue = isESGSolution?true:fProps.valueGetter('chkESG');
        // console.log('esgValue', esgValue)
        setCheckedChkESG(esgValue);

        if(!wclValue && !propertyValue && !tradeValue  && !govAValue && !esgValue) { //if purpose not selected, disabled Financing Amt.
            setDisableFinancingAmt(true);
        }
        else {
            setDisableFinancingAmt(false);
        }
         
        if(propertyValue && !wclValue && !tradeValue  && !govAValue && !esgValue) { //only property selected
        }
        else {
            setIsOnlyPropertyChecked(false);
        }
        
        return () => {
            console.log('clean up')
        }
    }, []);

    const checkIsOnlyPropertyChecked = (propChecked, wclChecked, tradeCheck, govaChecked, esgChecked) => {
        setDisableFinancingAmt(false);
        //change as long as propChecked, 200,000
        if(propChecked) {
            setIsOnlyPropertyChecked(true);
        }
        else {
            setIsOnlyPropertyChecked(false);
        }
    }
 
    return(
        <div>
            <FieldWrapper>
                <BlueboxTextList textList={mData.personalisedBlueboxTxtList} />
            </FieldWrapper>

            <Field component={HybridFormLabelGrey} labelId={'lblGray1'} labelName={mData.label.purposeOfFinancing} />
           
            <div className="scroll-row inputPair smallFontSize">
                <div className="p-col-wdt">
                    <div className={checkedChkWCL? 'yellowboxSmall':'greyboxSmall'}
                        onMouseEnter={() => {
                            setCard1Hover(true);
                        }}
                        onMouseLeave={()=> {
                            setCard1Hover(false);
                        }}>
                        <div className='greyboxSCenter'>
                            <Field id={'chkWorkingCapital'} name={'chkWorkingCapital'} label={'Select'} 
                                component={FormCheckboxSquare}
                                disabled={isEditForm}
                                onChange={(e) => {
                                    setCheckedChkWCL(e.value);
                                    setDisableFinancingAmt(false);
                                    // console.log('checkedChkESG: ',checkedChkESG)
                                    checkIsOnlyPropertyChecked(checkedChkProperty,e.value,checkedChkTrade,checkedChkGovAssist, checkedChkESG);
                                    props.onSelect(e.value,checkedChkProperty,checkedChkTrade,checkedChkGovAssist,checkedChkESG);
                                }} />

                            <div className='greyboxChkStyle'>
                            <img className='greyboxImg' src={wcIcon} alt='Working Capital' /></div>
                        </div>
                        <div className='greySboxLeft'>
                            <div className='greySboxBoldDiv'>
                                <div className='greySboxBold greySboxTxtPadding'>{'Working Capital'}</div>
                            </div>
                            <div className="divgreylineCpf" />
                            <div className='greySboxTxtPadding'>
                                {card1Hover?  
                                <ul className='dotlist'>
                                    <li>Short-term Financing</li>
                                    <li>Revolving credit</li>
                                    <li>Overdraft / Overdraft-i</li>
                                </ul>
                                :
                                <div className='greySboxTxtDesc'>
                                    Ensure smooth cash flow for your day-to-day business's needs.
                                </div>
                                }
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div className="p-col-wdt">
                    <div className={checkedChkProperty?'yellowboxSmall':'greyboxSmall'} 
                         onMouseEnter={() => {
                            setCard2Hover(true);
                        }}
                        onMouseLeave={()=> {
                            setCard2Hover(false);
                        }}>
                        <div className='greyboxSCenter'>
                            <Field id={'chkProperty'} name={'chkProperty'} label={'Select'} 
                                component={FormCheckboxSquare} 
                                disabled={isEditForm}
                                onChange={(e)=> {
                                    const propValue = e.value;
                                    setCheckedChkProperty(propValue);
                                    checkIsOnlyPropertyChecked(propValue,checkedChkWCL,checkedChkTrade,checkedChkGovAssist, checkedChkESG);
                                    props.onSelect(checkedChkWCL,propValue,checkedChkTrade,checkedChkGovAssist,checkedChkESG);
                                }}
                                />
                            <div className='greyboxChkStyle'><img className='greyboxImg' src={propertyIcon} alt='Property' /></div>
                            
                        </div>
                        <div className='greySboxLeft'>
                            <div className='greySboxBoldDiv'>
                                <div className='greySboxBold greySboxTxtPadding'>{'Property'}</div>
                            </div>
                            <div className="divgreylineCpf" />
                            <div className='greySboxTxtPadding'>
                                {card2Hover?
                                <ul className='dotlist'>
                                    <li>Purchase Asset</li>
                                    <li>Refinance Asset</li>
                                </ul>
                                :
                                <div className='greySboxTxtDesc'>
                                    Facilitate your business's property acquisition or refinancing needs.
                                </div>
                                }
                            </div>
                    
                        </div>
                    </div>
                </div>
                <div className="p-col-wdt">
                    <div className={checkedChkTrade? 'yellowboxSmall':'greyboxSmall'}
                       onMouseEnter={() => {
                            setCard3Hover(true);
                        }}
                        onMouseLeave={()=> {
                            setCard3Hover(false);
                        }}>
                        <div className='greyboxSCenter'>
                            <Field id={'chkTrade'} name={'chkTrade'} label={'Select'} 
                                component={FormCheckboxSquare}
                                disabled={isEditForm}
                                onChange={(e)=> {
                                    const tradeValue = e.value;
                                    setCheckedChkTrade(tradeValue);
                                    checkIsOnlyPropertyChecked(checkedChkProperty,checkedChkWCL,tradeValue,checkedChkGovAssist, checkedChkESG);
                                    props.onSelect(checkedChkWCL,checkedChkProperty,tradeValue,checkedChkGovAssist,checkedChkESG);
                                }}
                                />
                            <div className='greyboxChkStyle'><img className='greyboxImg' src={tradeIcon} alt='Trade' /></div>
                            
                        </div>
                        <div className='greySboxLeft'>
                            <div className='greySboxBoldDiv'>
                                <div className='greySboxBold greySboxTxtPadding'>{'Trade'}</div>
                            </div>
                            <div className="divgreylineCpf" />
                            <div className='greySboxTxtPadding'>
                            {card3Hover?
                                <ul className='dotlist'>
                                    <li>Import Trade Services</li>
                                    <li>Export Trade Services</li>
                                    <li>Guarantee Services</li>
                                </ul>
                                :
                                <div className='greySboxTxtDesc'>
                                    Expand your global trade and grow your import/ export capabilities.
                                </div>
                            }
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div className="p-col-wdt">
                    <div className={checkedChkGovAssist? 'yellowboxSmall':'greyboxSmall'}
                        onMouseEnter={() => {
                            setCard4Hover(true);
                        }}
                        onMouseLeave={()=> {
                            setCard4Hover(false);
                        }}>
                        <div className='greyboxSCenter'>
                            <Field id={'chkGovAssist'} name={'chkGovAssist'} label={'Select'} 
                                component={FormCheckboxSquare}
                                disabled={(isEditForm || (isESGSolution && esgSolutionType===mData.esgSolutionFType.Enterprise))?true:false}
                                onChange={(e)=> {
                                    const govaValue = e.value;
                                    setCheckedChkGovAssist(govaValue);
                                    checkIsOnlyPropertyChecked(checkedChkProperty,checkedChkWCL,checkedChkTrade,govaValue, checkedChkESG);
                                    props.onSelect(checkedChkWCL,checkedChkProperty,checkedChkTrade,govaValue,checkedChkESG);
                                }}
                                />
                            <div className='greyboxChkStyle'><img className='greyboxImg' src={govAssistIcon} alt='GovAssist' /></div>
                            
                        </div>
                        <div className='greySboxLeft'>
                            <div className='greySboxBoldDiv'>
                                <div className='greySboxBold greySboxTxtPaddingG'>
                                {'Government Assistance Scheme (Enterprise Financing Scheme)'}
                                </div>
                            </div>
                            <div className="divgreylineCpf" />
                            <div className='greySboxTxtPadding'>
                                {card4Hover?
                                <ul className='dotlist'>
                                    <li>SME Working Capital Loan</li>
                                    <li>Trade Loan</li>
                                </ul>
                                :
                                <div className='greySboxTxtDesc'>
                                    Government-backed working capital for SMEs in all industries.
                                </div>
                                }
                            </div>      
                        </div>
                    </div>
                </div>
                <div className="p-col-wdt">
                    <div className={checkedChkESG? 'yellowboxSmall':'greyboxSmall'}
                        onMouseEnter={() => {
                            setCard5Hover(true);
                        }}
                        onMouseLeave={()=> {
                            setCard5Hover(false);
                        }}>
                        <div className='greyboxSCenter'>
                            <Field id={'chkESG'} name={'chkESG'} label={'Select'} 
                                component={FormCheckboxSquare}
                                disabled={(isEditForm || isESGSolution)?true:false}
                                onChange={(e)=> {
                                    const esgValue = e.value;
                                    setCheckedChkESG(esgValue);
                                    checkIsOnlyPropertyChecked(checkedChkProperty,checkedChkWCL,checkedChkTrade,checkedChkGovAssist,esgValue);
                                    props.onSelect(checkedChkWCL,checkedChkProperty,checkedChkTrade,checkedChkGovAssist,esgValue);
                                }}
                                />
                            <div className='greyboxChkStyle'><img className='greyboxImg' src={esgIcon} alt='GovAssist' /></div>
                        </div>
                        <div className='greySboxLeft'>
                            <div className='greySboxBoldDiv'>
                                <div className='greySboxBold greySboxTxtPaddingG'>
                                {'Environmental, Social and Governance (ESG)'}
                                </div>
                            </div>
                            <div className="divgreylineCpf" />
                            <div className='greySboxTxtPadding'>
                                {card5Hover?
                                <ul className='dotlist'>
                                    <li>Carbon reduction</li>
                                    <li>Green & high tech</li>
                                    <li>Women entrepreneurs</li>
                                </ul>
                                :
                                <div className='greySboxTxtDesc'>
                                    Financing with amazing rates specially to help reach your ESG goals.
                                </div>
                                }
                            </div>      
                        </div>
                    </div>
                </div>
            </div>
            
            <FieldWrapper>
                <BlueboxEsgTxt textList={mData.esgBlueboxTxtList} />
            </FieldWrapper>

            <FieldWrapper> 
                <TotalFinancingAmt 
                    id={'totalFinancingAmtValue'}
                    name={'totalFinancingAmtValue'}
                    leftLabel={'Total Financing Amount'}
                    placeholder={'S$0'}
                    descLabel={isOnlyPropertyChecked?'Min. S$ 200,000 - Max. S$ 10,000,000':'Min. S$ 20,000 - Max. S$ 10,000,000'}
                    disabled={disableFinancingAmt}
                    validator={isOnlyPropertyChecked?min200KValidator:min20KValidator}
                />
            </FieldWrapper> 
        </div>
    )
}

export default PersonalisedBizFinancing